import { ref } from "vue";
import { defineStore } from "pinia";

import * as api from "@/app/api";
import { LoginController } from "@/app/actions/login";
import { useAlertStore } from "@/app/stores/alert.store";

export const useLoginStore = defineStore("login", () => {
    const loading = ref(false);
    const token = ref<api.Token | null>(LoginController.getToken());
    const user = ref<api.User | null>(null);

    async function login(username: string, password: string) {
        try {
            await LoginController.login(username, password);
        } catch (error) {
            console.error(error);
            return false;
        }
        return true;
    }

    function logout() {
        LoginController.logout();
        this.token = null;
        this.user = null;
    }

    async function get() {
        if (!this.token || this.loading) return;

        this.loading = true;

        try {
            const response = await api.getUserSelfApiV1LoginSelfGet();
            if ([401, 412].includes(response.response.status))
                LoginController.logout();

            if (response.error)
                useAlertStore().error(response.error as string);
            else
                this.user = response.data;
        } catch (e) {
            useAlertStore().error(e.message);
        } finally {
            this.loading = false;
        }

    }

    return { loading, token, user, login, logout, get };
});
